var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Home")]),_c('button',{on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")])])
}
var staticRenderFns = []

export { render, staticRenderFns }